var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('side-bar'),_c('div',{staticClass:"layout-right",style:({'left':_vm.sidebar.width})},[_c('nav-bar'),_c('div',{staticClass:"main-container",style:({height: _vm.Height + 'px'})},[_c('app-main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }